import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_Discharge = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_Discharge' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'> <h4>Contact Information</h4></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Admission Date:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Admission Diagnosis:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Discharge Date:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtAdmissionDate' name='txtAdmissionDate' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtAdmissionDiagnosis' name='txtAdmissionDiagnosis' className='add-only w-230 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtDischargeDate' name='txtDischargeDate' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Discharge Diagnosis:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Transfer Date:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Transfer Diagnosis:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtDischargeDiagnosis' name='txtDischargeDiagnosis' className='add-only w-230 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTransferDate' name='txtTransferDate' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTransferDiagnosis' name='txtTransferDiagnosis' className='add-only w-230 custom-add-only' />
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Client's Prognosis:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='cbOrientation' id='cbOrientation' className='add-only' value='1' /> Good
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='cbOrientation1' id='cbOrientation1' className='add-only' value='1' /> Fair
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='cbOrientation2' id='cbOrientation2' className='add-only' value='1' /> Poor
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Please explain:</span>
                    <textarea id='txtCircumstances' name='txtCircumstances' className='add-only '></textarea>
                </p>


                <p className='w-750'><h4>REASON FOR DISCHARGE OR TRANSFER</h4></p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' name='cbOrientation3' id='cbOrientation3' className='add-only' value='1' /> Completed treatment goals/plan at this level of care
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' name='cbOrientation4' id='cbOrientation4' className='add-only' value='1' /> Left before completing treatment goals/ plan
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <input type='checkbox' name='cbOrientation51' id='cbOrientation51' className='add-only' value='1' /> Transferred Voluntary (Specify):
                    <textarea id='txtCircumstances3' name='txtCircumstances3' className='add-only '></textarea>
                </p>


                <p className='w-750'>
                    <input type='checkbox' name='cbOrientation61' id='cbOrientation61' className='add-only' value='1' /> Discharged by agency for cause (e.g., non-compliance with agency rules) (Specify):
                    <textarea id='txtCircumstances41' name='txtCircumstances41' className='add-only '></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' name='cbOrientation5' id='cbOrientation5' className='add-only' value='1' /> Incarceration
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' name='cbOrientation6' id='cbOrientation6' className='add-only' value='1' /> Death
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>A narrative summary of the treatment episode including prognosis:</span>
                    <textarea id='txtCircumstances2' name='txtCircumstances2' className='add-only '></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Discharge/Transfer Plan:</span>
                    <textarea id='txtCircumstances31' name='txtCircumstances31' className='add-only '></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Recommendations:</span>
                    <textarea id='txtCircumstances4' name='txtCircumstances4' className='add-only '></textarea>
                </p>


                <p className='w-750'><h4>Risk Assessment</h4></p>


                <p className='w-750'>
                    <span className='eleHeader'>Was the client stable at Discharge?
                    </span>
                    <span className='small'>(no risk for suicide, homicide, psychosis)</span>
                    <input type='radio' id='rbRelationship_Yes' name='rbRelationship' className='add-only' value='1' /> Yes&nbsp;
                    <input type='radio' id='rbRelationship_No' name='rbRelationship' className='add-only' value='2' /> No
                </p>


                <p className='w-750'><h4>Aftercare</h4></p>

                
                <p className='w-750'>
                    <span className='eleHeader'>Was the client transitioned to aftercare, AA meeting or other services:</span>
                    <input type='radio' id='rbRelationship1_Yes' name='rbRelationship1' className='add-only' value='1' /> Yes&nbsp;
                    <input type='radio' id='rbRelationship1_No' name='rbRelationship1' className='add-only' value='2' /> No
                    <textarea id='txtCircumstances5' name='txtCircumstances5' className='add-only '></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Is a copy of this Discharge/Transfer Form provided to the client?</span>
                    <input type='radio' id='rbRelationship3_Yes' name='rbRelationship3' className='add-only' value='1' /> Yes&nbsp;
                    <input type='radio' id='rbRelationship3_No' name='rbRelationship3' className='add-only' value='2' /> No
                </p>


                <p className='w-750'>
                    Explain:
                    <textarea id='txtCircumstances6' name='txtCircumstances6' className='add-only '></textarea>
                </p>

            </div>
        </form>

    )
}

